import type { ModuleMigrationDef } from "@kubdee/sdk";

export const migration: ModuleMigrationDef = {
  key: "003_repair_payroll_and_slip_numbering",
  version: "1.0.2",
  sql: `
UPDATE \`core_numbering_series\`
SET
  \`prefix\` = CASE
    WHEN \`doctype\` = 'payroll_entry' THEN 'PAY-{YYYY}-{MM}-#####'
    WHEN \`doctype\` = 'salary_slip' THEN 'SS-{YYYY}-{MM}-#####'
    ELSE \`prefix\`
  END,
  \`reset_every\` = 'monthly',
  \`updated_at\` = strftime('%Y-%m-%dT%H:%M:%fZ', 'now')
WHERE
  \`module\` = 'hr'
  AND \`doctype\` IN ('payroll_entry', 'salary_slip')
  AND (
    (\`doctype\` = 'payroll_entry' AND \`prefix\` != 'PAY-{YYYY}-{MM}-#####')
    OR (\`doctype\` = 'salary_slip' AND \`prefix\` != 'SS-{YYYY}-{MM}-#####')
    OR \`reset_every\` != 'monthly'
  );
  `.trim(),
};
